export default "__VITE_ASSET__e34a3a66__"